import styled from 'styled-components';

export const StyledContainer = styled.section.attrs({
  className: 'px-4 py-10 mx-auto',
})``;

export const StyledAboutSectionWrapper = styled.div.attrs({ className: 'flex flex-col items-center justify-center' })``;
export const StyledAboutSectionProfessional = styled.div.attrs({
  className: 'mx-auto flex md:flex-row flex-col items-center mb-6',
})``;
export const StyledAboutSectionFirst = styled.div.attrs({
  className: 'lg:flex-grow md:w-1/2 lg:pr-24 md:pr-16 flex flex-col md:items-start md:text-left mb-16 md:mb-0 items-center text-center',
})``;
export const StyledAboutSectionSecond = styled.div.attrs({
  className: 'lg:max-w-lg lg:w-full md:w-1/2 w-5/6',
})``;

export const StyledAboutSectionPersonal = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  width: 100%;
`;

export const StyledResumeContainer = styled.div`
  margin: 20px;
`;
